export default __webpack_public_path__ + "static/media/MCAST.cfcbb86f.png";